const config = require('../config');
const apiConfig = require('../api-config');
const apiFactory = require('../resources/rm-access/api-factory');
const serviceFactory = require('../resources/rm-access/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/rmaccess/${apiConfig.apiversion}/`,
    // authToken: config.authToken,
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}bankerrmaccess.startRMSession[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.startRMSession(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

      .match(`${p}bankerrmaccess.getContractsList[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getContractsList(req.params)
          .then(response => res.value(response))
          .catch(res.error)
        )))

      .match(`${p}bankerrmaccess.rmSessionLogout[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.rmSessionLogout(req.params)
            .then(response => res.value(response))
            .catch(res.error)
        )))

        .match(`${p}bankerrmaccess.rmLogout`, requests => Promise.all(
          requests.map(({ req, res }) =>
            service.rmLogout(req.params)
              .then(response => res.value(response))
              .catch(res.error)
          )))
      }
     
  module.exports = addRoutes;
